import confirmEmailAddressTranslation from './index.json';

export default confirmEmailAddressTranslation;
